import { useQuery } from "@tanstack/react-query";
import { authenticatedGet, authenticatedPost } from "../../api/authenticatedFetch";

const BASE = "/api/v1/access-review";

// getAccessReview returns the tenant's periodic access-review status: whether
// a review is due, when it was last reviewed (and by whom), when the next one
// is due, the configured interval, the current tenant-owner membership
// (Sub-project D2, backend Tasks 1-4), and every platform-role
// (tenant_owner/security_admin) holder — permanent or temporary with its
// expiry — plus a count (Sub-project E4, Task 4). tenantOwners and
// platformHolders are always non-null arrays.
export const getAccessReview = async () => {
  const res = await authenticatedGet(BASE);
  return res?.access_review ?? res;
};

// acknowledgeAccessReview records that a tenant owner has reviewed the current
// tenant-owner membership, resetting the due clock. Returns the fresh status
// (status flips back to "ok", lastReviewedAt/nextDueAt update).
export const acknowledgeAccessReview = async ({ notes } = {}) => {
  const res = await authenticatedPost(`${BASE}/acknowledge`, { notes });
  return res?.access_review ?? res;
};

// --- react-query hooks ---

/**
 * `options.enabled` lets a caller that isn't guaranteed to hold
 * `access.review` (the endpoint's server-side gate) opt out of firing the
 * request at all — e.g. PlatformAssignmentsModal, which is mounted
 * regardless of the active Roles & Access tab and gated on the independent
 * `roles.assign` capability, would otherwise 403-spam this endpoint for a
 * roles.assign-without-access.review admin on every page visit.
 *
 * @param {{ enabled?: boolean }} [options]
 */
export function useAccessReview(options = {}) {
  return useQuery(["access-review"], getAccessReview, {
    refetchOnWindowFocus: false,
    ...options,
  });
}
